import React from 'react'
import { IElementProps } from '../../../types/interfaces'
import { enabledWhen, visibleWhen } from './common'

const Radio = (props: IElementProps) => {
  const optionsToRender = props.options
    .filter((o) => visibleWhen(o.visibleWhen, props.data))
    .map((o) => ({
      name: o.name,
      value: o.value,
      enabledWhen: enabledWhen(o.enabledWhen, props.data),
    }))

  return (
    <>
      {props.visible && (
        <div className={`formGroup ${props.class || ''}`}>
          <div className="labelTooltip">
            {props.translatedTooltip && (
              <>
                <div className="tooltipArea">
                  <i className="icon-info"></i>
                  <div className="tooltip">{props.translatedTooltip}</div>
                </div>
              </>
            )}
            <label>{props.label}</label>
          </div>
          <div className="control-group required-highlight">
            <div className="row">
              {props.options.length > 0 &&
                optionsToRender.map((option, i) => (
                  <div key={i} className="col-4">
                    <label className="control control-radio">
                      {option.name}
                      <input
                        disabled={props.formReadOnly || props.disabledInput || !option.enabledWhen}
                        type="radio"
                        value={option.value}
                        name={props.name}
                        checked={option.value === props.value}
                        onChange={(e) => props.handleChange(props.name, e)}
                      />
                      <div className="control_indicator" />
                    </label>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
export default Radio
